import { createFileRoute } from '@tanstack/react-router';

import { roleSchema } from '@nesso/identity-contracts/oauth.commands';

import { SignInPage, signInSearchSchema } from '@/pages/sign-in';

export const Route = createFileRoute('/login')({
    validateSearch: signInSearchSchema,
    component: SignInRoute,
});

function SignInRoute() {
    const { returnUrl, unlockToken } = Route.useSearch();
    const role = roleSchema.enum.clinician;
    return <SignInPage role={role} returnUrl={returnUrl} unlockToken={unlockToken} />;
}
